module.exports = __webpack_public_path__ + "static/media/hero.06908d6f.gif";